import React, { useState } from 'react';
import { useRouteMatch, useParams } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import LabelledTextBox from '../../components/LabelledTextBox';
import LabelledPicker from '../../components/LabelledPicker';
import { addHydrantDeficiency, updateHydrantDeficiency } from '../../services/api';
import useAuth from '../../services/authentication/useAuth';
import EventEmitter from '../../services/events';
import { makeHydrantDeficiency } from '../../models';
import LabelledCheckBox from '../../components/LabelledCheckBox';
import LabelledEditablePicker from '../../components/LabelledEditablePicker';

const DEFAULT_DEFICIENCY_TYPES = [
  'Leaking Barrel',
  'Hard to Turn',
  'Leaking Cap',
  'Leaking Top',
  'Turn Hydrant',
  'Marker'
];

const EditHydrantDeficiencyModal = ({ open, toggle, onComplete, onCancel, hydrantDeficiency }) => {
  const { companyId } = useAuth();
  const [hydrantDeficiencyState, setHydrantDeficiencyState] = useState(makeHydrantDeficiency({ ...hydrantDeficiency, companyId }));
  const { path, url } = useRouteMatch();

  const save = async () => {
    try {
      hydrantDeficiencyState.validate();
      const result = await updateHydrantDeficiency(hydrantDeficiencyState);
      onComplete(result.id);
    } catch (error) {
      console.log(error);
      if (error.name === 'ValidationError') {
        EventEmitter.emit('show-error', { title: 'Error Saving Hydrant Deficiency', body: error.message.split('\n').map((str, idx) => <p key={idx}>{str}</p>) });
      } else {
        EventEmitter.emit('show-error', { title: 'Error Saving Hydrant Deficiency', body: 'Unable to save hydrant deficiency.' });
      }
    }
  };

  const cancel = async () => {
    onCancel();
    setHydrantDeficiencyState(makeHydrantDeficiency({ ...hydrantDeficiency, companyId }));
  };

  const onChange = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case "number":
        value = +value;
        break;
      case 'checkbox':
        value = e.target.checked;
        break;
    }

    setHydrantDeficiencyState(makeHydrantDeficiency({ ...hydrantDeficiencyState, [e.target.name]: value }));
  };

  const onBlur = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case "number":
        value = +value;
        break;
      case 'checkbox':
        value = e.target.checked;
        break;
    }

    setHydrantDeficiencyState(makeHydrantDeficiency({ ...hydrantDeficiencyState, [e.target.name]: value }));
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader>
        <div>Edit Hydrant Deficiency</div>
      </ModalHeader>
      <ModalBody>
          <div className='details'>
            <LabelledEditablePicker label="Deficiency Type" value={hydrantDeficiencyState.deficiencyType} name="deficiencyType" onChange={onChange} onBlur={onBlur}>
              {DEFAULT_DEFICIENCY_TYPES.map((type, idx) => (
                <option key={idx} value={type}></option>
              ))}
            </LabelledEditablePicker>
            <LabelledTextBox label="Note" value={hydrantDeficiencyState.note} name="note" onChange={onChange} onBlur={onBlur} />
            <LabelledCheckBox label="Resolved" value={hydrantDeficiencyState.resolved} name="resolved" onChange={onChange} onBlur={onBlur} />
          </div>
      </ModalBody>
      <ModalFooter>
        <div className="actions">
          <button type="button" className="btn btn-secondary" onClick={cancel}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={save}>Save</button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default EditHydrantDeficiencyModal;